import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home-item-icon9",
  "use": "icon-home-item-icon9-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-home-item-icon9\">\n<path d=\"M14.6,2c1.3,0,2.3,1,2.3,2.3v11.4c0,1.3-1,2.3-2.3,2.3H5.4c-1.3,0-2.3-1-2.3-2.3V4.3C3.1,3,4.2,2,5.4,2H14.6z M7.1,12.9\n\tl-0.1,0c-0.3,0-0.5,0.3-0.5,0.6l0,0.1c0,0.3,0.3,0.5,0.6,0.5l4.2,0l-0.8,0.7l-0.1,0.1c-0.2,0.2-0.2,0.6,0.1,0.8\n\tc0.2,0.2,0.5,0.2,0.7,0l1.9-1.7l0.1-0.1c0.2-0.2,0.2-0.6-0.1-0.8c-0.1-0.1-0.2-0.1-0.4-0.1L7.1,12.9z M9.5,9C9.3,8.8,8.9,8.8,8.7,9\n\tc0,0,0,0,0,0l-1.9,1.7l-0.1,0.1c-0.2,0.2-0.2,0.6,0.1,0.8c0.1,0.1,0.2,0.1,0.4,0.1l5.7,0l0.1,0c0.3,0,0.5-0.3,0.5-0.6l0-0.1\n\tc0-0.3-0.3-0.5-0.6-0.5l-4.2,0l0.8-0.7l0.1-0.1C9.7,9.6,9.7,9.3,9.5,9L9.5,9z M9.4,5.4H6C5.7,5.4,5.4,5.7,5.4,6\n\tc0,0.3,0.3,0.6,0.6,0.6h3.4C9.7,6.6,10,6.3,10,6C10,5.7,9.7,5.4,9.4,5.4z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home-item-icon9.svg
// module id = LReq
// module chunks = 97